import { useState } from "react";
import axios from "axios";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "https://manirajbuilder.com/contact.php",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      alert(res.data.message || "Message sent successfully!");
      setFormData({ name: "", phone: "", email: "", message: "" }); // Reset form
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div>
      {/* Header */}
      <div
        style={{
          padding: "40px",
          backgroundColor: "#f9f9f9",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "4rem",
            color: "rgba(35, 120, 97, 1)",
            fontFamily: "'Work Sans', 'sans-serif'",
            marginBottom: "20px",
          }}
        >
          Get in Touch
        </h2>
      </div>

      {/* Main Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          justifyContent: "center",
          padding: "40px 20px",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Form */}
        <div style={{ flex: "1", minWidth: "300px", padding: "20px" }}>
          <h2
            style={{
              marginBottom: "20px",
              color: "rgba(35, 120, 97, 1)",
              fontFamily: "'Work Sans', 'sans-serif'",
              fontSize: "2rem",
            }}
          >
            Send Us a Message
          </h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="name">Name:</label>
              <input
                id="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="phone">Phone:</label>
              <input
                id="phone"
                type="text"
                value={formData.phone}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="email">Email:</label>
              <input
                id="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  resize: "none",
                }}
              ></textarea>
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: "#23a561",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div style={{ flex: "1", minWidth: "300px", padding: "20px" }}>
          <h2
            style={{
              marginBottom: "20px",
              color: "rgba(35, 120, 97, 1)",
              fontFamily: "'Work Sans', 'sans-serif'",
              fontSize: "2rem",
            }}
          >
            Contact Info
          </h2>
          <p style={{ marginBottom: "20px", color: "rgba(35, 120, 97, 1)" }}>
            9934822681, 9431998677
          </p>
          <p style={{ marginBottom: "20px" }}>manirajbuilder@gmail.com</p>
          <p>Nawadih, Hirak Road, Dhanbad, Jharkhand</p>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
